import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const embedCtaButtonClass =
  'inline-flex w-full max-w-xs items-center justify-center gap-2 rounded-full bg-accent px-6 py-3 text-sm font-bold text-accent-foreground shadow-md transition-opacity hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-canvas sm:max-w-sm sm:px-8 sm:py-3.5 sm:text-base';

export const promoEmbedShellClass =
  'mt-6 flex min-h-0 flex-1 flex-col rounded-2xl bg-surface p-3 sm:p-4 shadow-sm border border-edge text-left';

export const promoEmbedBodyClass = 'min-h-0 flex-1';

function PromotionalEmbedCta({
  to = '/jupas-calculator',
  labelKey = 'promotionalHome.embed.openJupaselect'
}) {
  const { t } = useTranslation();

  return (
    <div className="mt-auto flex justify-center border-t border-edge pt-5">
      <Link to={to} className={embedCtaButtonClass}>
        {t(labelKey)}
      </Link>
    </div>
  );
}

export default PromotionalEmbedCta;
